import { call } from '@advanza/api'
import { Button, Icon, LoadingDots } from '@advanza/ui'
import queryString from 'query-string'
import { useState } from 'react'

interface ReportExportButtonProps {
    exportEndpoint: string
    filters?: Record<string, any>
    country?: string
}

const ReportExportButton = ({ exportEndpoint, filters = {}, country }: ReportExportButtonProps) => {
    const [isExporting, setIsExporting] = useState(false)
    const [response, setResponse] = useState<any>(null)

    const handleExport = () => {
        if (!isExporting) {
            setIsExporting(true)

            // Get current URL parameters as fallback
            const urlParams = queryString.parse(window.location.search, {
                arrayFormat: 'bracket',
            })

            // Build query parameters from props (same as normal fetch)
            // Use URL params as fallback if Redux filters are empty
            const effectiveFilters = Object.keys(filters).length > 0 ? filters : urlParams
            const effectiveCountry = country || urlParams.country

            const queryParams = {
                ...effectiveFilters,
                ...(effectiveCountry && { country: effectiveCountry }),
            }

            // Convert to query string
            const urlSearchParams = new URLSearchParams()
            Object.entries(queryParams).forEach(([key, value]) => {
                if (value !== null && value !== undefined && value !== '') {
                    if (Array.isArray(value)) {
                        value
                            .filter(
                                (v): v is string | null =>
                                    v !== null && v !== undefined && v !== '',
                            )
                            .forEach((v) =>
                                urlSearchParams.append(`${key}[]`, v === null ? '' : v.toString()),
                            )
                    } else {
                        urlSearchParams.append(key, value.toString())
                    }
                }
            })

            const queryStringParam = urlSearchParams.toString()
            const url = queryStringParam ? `${exportEndpoint}?${queryStringParam}` : exportEndpoint

            call(url)
                .then(setResponse, setResponse)
                .finally(() => setIsExporting(false))
        }
    }

    const iconName = (() => {
        if (isExporting) {
            return 'hourglass_full'
        }
        if (response && response.scheduled) {
            return 'sentiment_very_satisfied'
        }
        return 'file_download'
    })()
    const buttonContent = (() => {
        if (isExporting) {
            return <LoadingDots />
        }
        if (!response) {
            return 'Export sheet'
        }
        return response.scheduled ? 'Scheduled export task' : 'Error'
    })()
    return (
        <Button
            onClick={handleExport}
            disabled={isExporting}
            variant="primary"
            before={<Icon name={iconName} />}>
            {buttonContent}
        </Button>
    )
}

export default ReportExportButton
